import axios from 'axios';
import qs from 'qs';
import { get } from 'lodash';

const DOWNLOADS_LIST_LOAD = 'DOWNLOADS_LIST_LOAD';
const DOWNLOADS_LIST_SUCCESS = 'DOWNLOADS_LIST_SUCCESS';
const DOWNLOADS_LIST_FAILED = 'DOWNLOADS_LIST_FAILED';
const DOWNLOADS_SET_LOADING = 'DOWNLOADS_SET_LOADING';

const DOWNLOADS_FORM_LOAD = 'DOWNLOADS_FORM_LOAD';
const DOWNLOADS_FORM_SUCCESS = 'DOWNLOADS_FORM_SUCCESS';
const DOWNLOADS_FORM_FAILED = 'DOWNLOADS_FORM_FAILED';

const DOWNLOAD_DELETE_LOAD = 'DOWNLOAD_DELETE_LOAD';
const DOWNLOAD_DELETE_SUCCESS = 'DOWNLOAD_DELETE_SUCCESS';
const DOWNLOAD_DELETE_FAILED = 'DOWNLOAD_DELETE_FAILED';

const DOWNLOAD_EDIT_LOAD = 'DOWNLOAD_EDIT_LOAD';
const DOWNLOAD_EDIT_SUCCESS = 'DOWNLOAD_EDIT_SUCCESS';
const DOWNLOAD_EDIT_FAILED = 'DOWNLOAD_EDIT_FAILED';

const DOWNLOAD_VIEW_LOAD = 'DOWNLOAD_VIEW_LOAD';
const DOWNLOAD_VIEW_SUCCESS = 'DOWNLOAD_VIEW_SUCCESS';
const DOWNLOAD_VIEW_FAILED = 'DOWNLOAD_VIEW_FAILED';

const DOWNLOADS_RESET = 'DOWNLOADS_RESET';
const DOWNLOADS_RESET_FORM = 'DOWNLOADS_RESET_FORM';

const initialState = {
  loading: false,
  success: false,
  saved: false,
  failed: false,
  data: [],
  message: null,
  total: 0,
  limit:process.env.REACT_APP_LIST_LIMIT,
  page: null,
  order: '',
  orderMode: 'ASC',
  deleted: false,
  deletedId: null,
  formErrors: {},
  viewData: null,
  viewLoading: false,
  commentThread: false,
  id: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOADS_RESET:
      return {
        ...initialState
      };
    case DOWNLOADS_RESET_FORM:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        formErrors: {},
        viewData: null,
        viewLoading: false,
        commentThread: false,
        id: null
      };
    case DOWNLOAD_DELETE_LOAD:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        viewLoading: false
      };
    case DOWNLOADS_LIST_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        viewLoading: false
      };
    case DOWNLOAD_EDIT_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: false
      };
    case DOWNLOAD_VIEW_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: true
      };
    case DOWNLOADS_FORM_LOAD:
      return {
        ...state,
        loading: false,
        failed: false,
        message: null,
        viewLoading: false
      };
    case DOWNLOADS_FORM_FAILED:
    case DOWNLOAD_EDIT_FAILED:
    case DOWNLOAD_DELETE_FAILED:
    case DOWNLOADS_LIST_FAILED:
    case DOWNLOAD_VIEW_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        saved: false,
        failed: true,
        message: action.message,
        formErrors: action.formErrors || {},
        deleted: true,
        deletedId: null,
        viewLoading: false
      };
    case DOWNLOADS_LIST_SUCCESS:
      return {
        ...state,
        success: true,
        failed: false,
        data: action.data,
        total: action.total,
        limit: action.limit,
        page: action.page,
        order: action.order,
        orderMode: action.orderMode
      };
      case DOWNLOAD_VIEW_SUCCESS:
        return {
            ...state,
            loading: false,
            success: true,
            failed: false,
            viewData: action.viewData,
            viewLoading: false
        };
    case DOWNLOADS_FORM_SUCCESS:
      return {
        ...state,
        fields: action.fields,
        loading: false,
        success: true,
        failed: false,
        viewLoading: false
      };
    case DOWNLOAD_DELETE_SUCCESS:
      return {
        ...state,
        deleted: true,
        deletedId: action.id
      };
    case DOWNLOAD_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        failed: false,
        message: null,
        formErrors: {},
        id: action.id,
        viewLoading: false
      };
    case DOWNLOADS_SET_LOADING:
      return {
        ...state,
        loading: action.loading,
        viewLoading: false
      };
    default:
      return state;
  }
}

export const reset = () => dispatch => {
  dispatch({
    type: DOWNLOADS_RESET
  });
};

export const resetForm = () => dispatch => {
  dispatch({
    type: DOWNLOADS_RESET_FORM
  });
};

export const updateDownloads = (model,id,data) => dispatch => {
  dispatch({
    type: DOWNLOAD_EDIT_LOAD
  });

    let obj = {};
    obj[model] = data;

  return axios.put('/v1/downloads/'+id, obj).then(
      () => dispatch({
        type: DOWNLOAD_EDIT_SUCCESS
      })
  ).catch(error => {
    dispatch({
      type: DOWNLOAD_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const viewDownloads = (id) => dispatch => {
    dispatch({
        type: DOWNLOAD_VIEW_LOAD
    });
    return axios.get('/v1/downloads/'+id).then(
        response => dispatch({
            type: DOWNLOAD_VIEW_SUCCESS,
            viewData: get(response, 'data.data'),
            commentThread: get(response, 'data.commentThread', false)
        })
    ).catch(error => {
        dispatch({
            type: DOWNLOAD_VIEW_FAILED,
            message: get(error, 'response.data.message', null)
        })
    });
};

export const createDownloads = (model, data) => dispatch => {
  dispatch({
    type: DOWNLOAD_EDIT_LOAD
  });

  let obj = {};
  obj[model] = data;

  return axios.post('/v1/downloads', obj).then(response => dispatch({
    type: DOWNLOAD_EDIT_SUCCESS,
    id: get(response, 'data.data.id', null),
  })).catch(error => {
    dispatch({
      type: DOWNLOAD_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const downloadDelete = (id) => dispatch => {
  dispatch({
    type: DOWNLOAD_DELETE_LOAD
  });
  return axios.delete('/v1/downloads/'+id)
      .then((response) => dispatch({
        type: DOWNLOAD_DELETE_SUCCESS,
        id
      })).catch(error => dispatch({
        type: DOWNLOAD_DELETE_FAILED,
        message: get(error, 'response.data.message', null)
      }));
};

export const setLoading = (loading) => dispatch => {
  dispatch({
    type: DOWNLOADS_SET_LOADING,
    loading
  });
};

export const downloadsList = (page, keyword, sort, filters, perPage) => dispatch => {
  dispatch({
    type: DOWNLOADS_LIST_LOAD
  });

  let params = {
    page,
    keyword,
    sort,
    'per-page': perPage
  };

  params[filters.model] = filters.filters;

  return axios.get(
      '/v1/downloads',
      {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
  ).then(response => {
    let sort = get(response, 'data.sort', null),
        mode = 'ASC';
    if(sort && sort.indexOf('-') !== -1) {
      mode = 'DESC';
      sort = sort.substr(1);
    }
    return dispatch({
      type: DOWNLOADS_LIST_SUCCESS,
      data: get(response, 'data.data', null),
      page: get(response, 'data.page', 0),
      limit: get(response, 'data.per-page', 0),
      total: get(response, 'data.total', 0),
      order: sort,
      orderMode: mode
    });
  })
  .catch(error => dispatch({
    type: DOWNLOADS_LIST_FAILED,
    message: get(error, 'response.data.message', null)
  }));
};



// WEBPACK FOOTER //
// ./src/redux/modules/downloads.js